export default __webpack_public_path__ + "static/media/chatbot.35621985.png";